import config from '../config';

// Redact obvious secrets before shipping params to the log.
const REDACT_KEYS = /password|token|secret|authorization|apikey|card|cvv|ssn/i;

function redact(value) {
    if (value === null || value === undefined) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(redact);
    }
    if (typeof value === 'object') {
        const out = {};
        for (const [k, v] of Object.entries(value)) {
            out[k] = REDACT_KEYS.test(k) ? '[REDACTED]' : redact(v);
        }
        return out;
    }
    return value;
}

function classify(err) {
    if (!err) {
        return 'unknown';
    }
    const status = err.status || err.statusCode || err.response?.status;
    if (status) {
        return `http_${status}`;
    }
    const msg = (err.message || String(err)).toLowerCase();
    if (msg.includes('networkerror') || msg.includes('failed to fetch')) {
        return 'network';
    }
    if (msg.includes('timeout') || msg.includes('timed out')) {
        return 'timeout';
    }
    if (msg.includes('abort')) {
        return 'aborted';
    }
    return 'error';
}

export function reportChaos(payload) {
    try {
        const body = JSON.stringify({
            url: window.location.href,
            ...payload
        });
        // eslint-disable-next-line no-console
        console.debug(
            '[chaosReporter]',
            payload.kind,
            payload.category,
            payload.operation || payload.message
        );
        fetch(`${config.apiUrl}/chaos/report`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
            keepalive: true
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.warn('[chaosReporter] failed to POST', err);
        });
    } catch (_) {
        // Never let the reporter itself break the app.
    }
}

export function reportApiFailure(api, operation, params, err) {
    reportChaos({
        kind: 'api',
        api,
        operation,
        params: redact(params),
        category: classify(err),
        status: err?.status || err?.statusCode || null,
        message: err?.message || String(err)
    });
}

export function reportGlobalError(kind, err) {
    reportChaos({
        kind,
        category: classify(err),
        message: err?.message || String(err),
        stack: err?.stack || null
    });
}
